import React from "react";
import styled from "styled-components";
import { GroupRowOld } from "../components";

const ListView = ({ group }) => {
  if (!group) {
    return <div>Ha ocurrido un error cargando la clasificación</div>;
  }

  const lastPosition = group.players.length;

  return (
    <Wrapper>
      {/* {group.groupId === "3dbc1815-2302-4388-b2e9-ab37856fc845" ||
      group.groupId === "e4b7ace1-fa91-4389-acba-ecab3844c65a" ? (
        <div className="infoBox">
          Debido a que en este grupo el número de jugadores es impares, cada
          jugador descansará 1 jornada.
          <br />
          Esta división al tener menos jugadores que el resto tendrá un playoff
          más largo. En breve os daremos más detalles.
        </div>
      ) : (
        ""
      )} */}
      <div className="row header">
        <div className="x1">#</div>
        <div className="x3">Jugador</div>
        <div className="x2">Puntos</div>
        <div className="x2">
          Series
          <br />
          V-D
        </div>
        <div className="x2">
          Mapas
          <br />
          V-D
        </div>
        <div className="x3 matches-history">Partidas</div>
      </div>
      <hr />
      {group.players.map((player) => {
        //console.log("Player:");
        //console.log(player);
        return (
          <GroupRowOld
            key={`GroupRow-${player.playerId}-${player.position}`}
            {...player}
            lastPosition={lastPosition}
          />
        );
      })}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  width: 100%;

  .infoBox {
    background-color: var(--clr-primary);
    padding: 2rem;
    margin-bottom: 2rem;

    a {
      color: var(--clr-black);
      font-weight: bold;
    }
  }
  .row {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 3rem;
  }

  hr {
    border-color: var(--clr-grey-10);
  }
  .x1 {
    width: 2rem;
    margin: 1rem;
    display: flex;
    justify-content: center;
  }

  .x2 {
    width: 6rem;
    margin: 1rem;
    display: flex;
    justify-content: center;
  }

  .x3 {
    width: 28rem;
    margin: 1rem;
  }

  .x4 {
    width: 56rem;
    margin: 1rem;
  }

  .header {
    font-weight: bold;
  }

  @media (max-width: 600px) {
    .matches-history {
      display: none;
    }

    .x1 {
      width: 2rem;
      margin: 0.5rem;
      display: flex;
      justify-content: center;
    }

    .x2 {
      width: 6rem;
      margin: 0.5rem;
      display: flex;
      justify-content: center;
    }

    .x3 {
      width: 28rem;
      margin: 0.5rem;
    }

    .x4 {
      width: 56rem;
      margin: 0.5rem;
    }
    .position {
      height: 100%;
      width: 0.5rem;
    }
  }
`;

export default ListView;
